import { useQuery as useQueryBase, } from '@tanstack/react-query';
import { NetworkRequestError } from '@annunciate/query';
import { request } from '../../request';
export function useQuery(key, query, endpoint, variables, options, responseMapper = (response) => response) {
    let cacheKey = key;
    if (variables && Array.isArray(key)) {
        cacheKey = [...cacheKey, variables];
    }
    else if (variables !== undefined) {
        cacheKey = [cacheKey, variables];
    }
    return useQueryBase({
        queryKey: cacheKey,
        queryFn: async () => {
            try {
                const response = await request({
                    query,
                    endpoint,
                    variables,
                });
                return responseMapper(response);
            }
            catch (err) {
                if (err.message === 'Network request failed') {
                    throw new NetworkRequestError();
                }
                else {
                    throw err;
                }
            }
        },
        gcTime: 3 * 60 * 1000,
        ...options,
    });
}
//# sourceMappingURL=useQuery.js.map